import React, { useEffect, useState } from 'react';
import { RadioButtonGroup, RadioGroup } from 'react-rainbow-components';

const OPTIONS = [
  { label: 1, value: '1' },
  { label: 2, value: '2' },
  { label: 3, value: '3' },
  { label: 4, value: '4' },
  { label: 5, value: '5' }
];

export interface ScoreChange {
  [group: string]: number;
}

interface Props {
  group: string;
  onScoreChange?: (score: ScoreChange) => void;
  onValueChange?: (value: string) => void;
  title: string;
  value?: string;
}

const Question: React.FC<Props> = ({
  group,
  onScoreChange,
  onValueChange,
  title,
  value
}) => {
  const [innerWidth, setInnerWidth] = useState(window.innerWidth);

  function handleChange(e: any) {
    const groupNames = group.split('|');

    switch (e.target.value) {
      case '1':
        if (onScoreChange) {
          onScoreChange({
            [groupNames[0]]: 0,
            [groupNames[1]]: 5
          });
        }
        if (onValueChange) {
          onValueChange('1')
        }
        break;

      case '2':
        if (onScoreChange) {
          onScoreChange({
            [groupNames[0]]: 1,
            [groupNames[1]]: 4
          });
        }
        if (onValueChange) {
          onValueChange('2')
        }
        break;

      case '3':
        if (onScoreChange) {
          onScoreChange({
            [groupNames[0]]: 2,
            [groupNames[1]]: 2
          });
        }
        if (onValueChange) {
          onValueChange('3')
        }
        break;

      case '4':
        if (onScoreChange) {
          onScoreChange({
            [groupNames[0]]: 4,
            [groupNames[1]]: 1
          });
        }
        if (onValueChange) {
          onValueChange('4')
        }
        break;

      default:
        if (onScoreChange) {
          onScoreChange({
            [groupNames[0]]: 5,
            [groupNames[1]]: 0
          });
        }
        if (onValueChange) {
          onValueChange('5')
        }
    }
  }

  useEffect(() => {
    window.onresize = () => {
      setInnerWidth(window.innerWidth);
    };
  }, []);

  return (
    <div style={{ paddingBottom: 10 }}>
      <p style={{ padding: '10px 0 5px 0', textAlign: 'center' }}>
        {title}
      </p>
      {
        innerWidth >= 435 && (
          <RadioButtonGroup
            onChange={handleChange}
            options={OPTIONS}
            style={{ display: 'flex' }}
            value={value}
            variant="brand"
          />
        )
      }
      {
        innerWidth < 435 && (
          <RadioGroup
            onChange={handleChange}
            options={OPTIONS}
            value={value}
          />
        )
      }
    </div>
  );
}

export default Question;
